<template>
  <div>
    plop
  </div>
</template>

<script>
export default {
  created () {
    console.log('areyuh')
  }
}
</script>